import { render, staticRenderFns } from "./minepic.vue?vue&type=template&id=18ae22f4&scoped=true&"
import script from "./minepic.vue?vue&type=script&lang=js&"
export * from "./minepic.vue?vue&type=script&lang=js&"
import style0 from "./minepic.vue?vue&type=style&index=0&id=18ae22f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae22f4",
  null
  
)

export default component.exports